<template lang="pug">
  include /mixins
  div
    +b.ds-panel.--space_lg(v-if="filter.items.length > 20")
      +e.element.--offset_bottom
        d-control-static-input(
          v-model='searchValue',
          @input="searchAttrs"
          type="text"
          :placeholder="_('Пошук')"
        )
    +b.g-row.--appearance_spaced
      +b.g-cell.g-cols--12-xs(v-for='choice in filter.items' :key="choice.slug")
        +b.LABEL.d-control-checkbox.--variant_flex
          +e.INPUT.element(
            :name="filter.label"
            type='checkbox'
            :value="choice.slug"
            v-model='checked'
            @change='submit'
          )
          +e.label
          +e.SPAN.color-swatch(
            v-if="choice.color"
            :style="{ '--swatch': choice.color }"
            :class="{ 'for-white': isLightColor(choice.color) }"
          )
          +e.SPAN.content {{ choice.label }}
</template>
<script>
export default {
  name: 'CheckboxWidget',

  props: ['value', 'filter'],

  data() {
    return {
      checked: [],
      searchValue: null,
      choicesLocal: [],
    }
  },

  watch: {
    value(nval) {
      this.checked = this.normalize(nval)
    },

    filter: {
      deep: true,
      immediate: true,
      handler(nval) {
        if (nval && nval.values) {
          this.choicesLocal = nval.values
        }
      },
    },
  },

  mounted() {
    this.checked = this.normalize(this.value)
  },

  methods: {
    submit() {
      this.$emit('input', this.checked)
    },

    normalize(value) {
      let val = value
      if (!value) return []
      if (!Array.isArray(value)) {
        val = [value]
      }

      const checked = this.filter.items
        .filter(el => val.find(v => String(v) === el.slug)).map(el => el.slug)

      return checked
    },

    searchAttrs() {
      this.$nextTick(() => {
        const choices = JSON.parse(JSON.stringify(this.filter.values))

        this.choicesLocal = choices.filter(choice => {
          const searchVal = this.searchValue.toLowerCase()
          const choiceName = choice.values[0].toLowerCase()
          if (choiceName.includes(searchVal)) {
            return choice
          }
          return false
        })
      })
    },
    isLightColor(hex) {
      if (!hex) return false
      const color = hex.replace('#', '')
      const r = parseInt(color.substring(0, 2), 16)
      const g = parseInt(color.substring(2, 4), 16)
      const b = parseInt(color.substring(4, 6), 16)
      const brightness = (r * 299 + g * 587 + b * 114) / 1000
      return brightness > 200
    },
  },
}
</script>
